export default "__VITE_ASSET__BlhOsOlS__"